angular
  .module('contrast.attacks.monitor', [])
  .controller(
    'AttackMonitorCtrl',
    function (
      $rootScope,
      $scope,
      $timeout,
      $location,
      $q,
      $translate,
      AttackMonitorService,
      LoadFilterService,
      UserService,
      DebounceService,
      PromiseService,
      TimeService,
      LoadFilterRouteService,
      ATTACK_MONITOR_FILTER_GROUPS,
      QUICK_FILTERS,
      UNKNOWN_SOURCE_KEY
    ) {
      'ngInject'

      var vm,
        filterChange,
        filterChangeNow,
        attackersPromise,
        eventsPromise,
        appsPromise,
        filtersPromise,
        currentEnvironment

      this.$onInit = function () {
        vm = this
        filterChange = DebounceService(reloadData, 200, false)
        filterChangeNow = DebounceService(reloadData, 0, true)
        attackersPromise = null
        eventsPromise = null
        appsPromise = null
        filtersPromise = null
        currentEnvironment = null

        angular.extend(vm, {
          filterChange: filterChange,
          filterChangeNow: filterChangeNow,
          environmentChange: environmentChange,
          clearFilters: clearFilters,
          attackersCountClick: attackersCountClick,
          attackersNameClick: attackersNameClick,
          eventsCountClick: eventsCountClick,
          appsCountClick: appsCountClick,
          onHighRiskClick: onHighRiskClick
        })

        angular.extend(vm, {
          filters: AttackMonitorService.filters(),

          noAttacks: false,

          attackers: {
            total: 0,
            count: 0,
            attackers: [],
            remaining_attackers: null,
            remaining_breakdown: null,
            clickHandler: attackerSelect,
            remainingClickHandler: attackerMultiSelect
          },
          attackersPromise: null,
          attackersLoaded: false,
          getAttackType: getAttackType,

          events: {
            total: 0,
            totalAttacks: 0,
            items: [],
            remaining_events: null,
            remaining_value: null,
            classAccessor: AttackMonitorService.eventsClassAccessor,
            nameClickHandler: onEventNameClick,
            clickHandler: eventSelect,
            remainingClickHandler: eventMultiSelect
          },
          eventsPromise: null,
          eventsLoaded: false,

          apps: {
            total: 0,
            totalAttacks: 0,
            items: [],
            remaining_applications: null,
            remaining_value: null,
            classAccessor: AttackMonitorService.eventsClassAccessor,
            nameClickHandler: onAppNameClick,
            clickHandler: appSelect,
            remainingClickHandler: appMultiSelect
          },
          appsPromise: null,
          appsLoaded: false,

          filtersLoaded: false,
          filtersPromise: null,

          stats: {},
          statsPromise: null,
          statsLoaded: false,

          knobSettings: {
            animate: {
              enabled: true,
              duration: 500,
              ease: 'linear'
            },
            readOnly: true,
            trackColor: 'EEEEEE',
            trackWidth: 10,
            barWidth: 10,
            step: 1,
            max: 100,
            displayInput: false,
            size: 85
          },

          unknownSourceKey: UNKNOWN_SOURCE_KEY
        })

        // check default filter and set start/end if null
        if (
          vm.filters.date.label === 'Last day' &&
          (!vm.filters.date.startDate || !vm.filters.date.endDate)
        ) {
          const date = TimeService.getLastDay()
          vm.filters.date.startDate = date.startDate
          vm.filters.date.endDate = date.endDate
        }

        // TODO: CONTRAST-18296
        // eslint-disable-next-line angular/on-watch
        $rootScope.$on(
          'attackscount:loaded',
          function (_e, attacksCountsChanged) {
            if (attacksCountsChanged && isViewingLive()) {
              filterChangeNow()
            }
          }
        )

        init()
      }

      function init() {
        vm.statsPromise = getMonitorStats()
        vm.attackersPromise = getAttackers()
        vm.eventsPromise = getEvents()
        vm.appsPromise = getApps()
        vm.filtersPromise = getFilters()

        $scope.$watch(
          function () {
            return vm.filters.date.label
          },
          function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
              onDateOptionChange()
            }
          }
        )
        onDateOptionChange()

        currentEnvironment = vm.filters.environment.value

        $scope.$on('$destroy', _destroy)
      }

      function _destroy() {
        $rootScope.$broadcast('changeFooterBottom', {
          shouldSendToBottom: false
        })
      }

      function getMonitorStats() {
        return AttackMonitorService.getStats().then(function (stats) {
          vm.stats = stats
          $timeout(function () {
            vm.statsLoaded = true
          }, 400)
        })
      }

      function getAttackers(hasFilters, keepFilters) {
        vm.attackersLoaded = false

        if (attackersPromise) {
          PromiseService.cancelPromise(attackersPromise)
        }

        attackersPromise = AttackMonitorService.getAttackers(
          vm.filters,
          hasFilters && keepFilters ? vm.attackers : null,
          !keepFilters
        )

        return attackersPromise.then(function (data) {
          if (data) {
            vm.attackers.attackers = data.attackers
            vm.attackers.total = data.total
            vm.attackers.count = data.count

            vm.attackers.remaining_attackers = data.remaining_attackers
            vm.attackers.remaining_breakdown = data.remaining_breakdown
          }

          if (keepFilters || !hasFilters) {
            vm.attackersLoaded = true
          }
        })
      }

      function getEvents(hasFilters, keepFilters) {
        vm.eventsLoaded = false

        if (eventsPromise) {
          PromiseService.cancelPromise(eventsPromise)
        }

        eventsPromise = AttackMonitorService.getEvents(
          vm.filters,
          hasFilters && keepFilters ? vm.events : null,
          !keepFilters
        )

        return eventsPromise.then(function (data) {
          if (data) {
            vm.events.items = data.items
            vm.events.total = data.total
            vm.events.totalAttacks = data.totalAttacks
            vm.events.remaining_breakdown = data.remaining_breakdown
            vm.events.remaining_events = data.remaining_events
          }

          if (keepFilters || !hasFilters) {
            vm.eventsLoaded = true
          }
        })
      }

      function getApps(hasFilters, keepFilters) {
        vm.appsLoaded = false

        if (appsPromise) {
          PromiseService.cancelPromise(appsPromise)
        }

        appsPromise = AttackMonitorService.getApps(
          vm.filters,
          hasFilters && keepFilters ? vm.apps : null,
          !keepFilters
        )

        return appsPromise.then(function (data) {
          if (data) {
            vm.apps.items = data.items
            vm.apps.total = data.total
            vm.apps.totalAttacks = data.totalAttacks
            vm.apps.remaining_breakdown = data.remaining_breakdown
            vm.apps.remaining_applications = data.remaining_applications
          }

          if (keepFilters || !hasFilters) {
            vm.appsLoaded = true
          }
        })
      }

      function getFilters() {
        vm.filtersLoaded = false

        if (filtersPromise) {
          PromiseService.cancelPromise(filtersPromise)
        }

        filtersPromise = AttackMonitorService.getFilters(vm.filters)

        return filtersPromise.then(function (data) {
          if (data) {
            vm.filters.availableFilters = data
          }

          vm.filtersLoaded = true
        })
      }

      function onEventNameClick(ruleUUID) {
        return function () {
          _setBotBlockerIpFilters()
          LoadFilterService.setAttackEventRules([ruleUUID])
          $location.path(UserService.buildUrl('/attacks/events'))
        }
      }

      function onAppNameClick(appId) {
        return function () {
          _setBotBlockerIpFilters()
          LoadFilterService.setAttackEventApps([appId])
          $location.path(UserService.buildUrl('/attacks/events'))
        }
      }

      function environmentChange() {
        vm.filters.environmentFilters[currentEnvironment] = vm.filters.selected
        currentEnvironment = vm.filters.environment.value
        vm.filters.selected = mergeSubfilters(
          vm.filters.selected,
          vm.filters.environmentFilters[currentEnvironment]
        )
        filterChange()
      }

      function reloadData(keepFilters) {
        var hasFilters = vm.filters.selected.length > 0

        vm.attackersPromise = getAttackers(hasFilters, keepFilters)
        vm.eventsPromise = getEvents(hasFilters, keepFilters)
        vm.appsPromise = getApps(hasFilters, keepFilters)

        var promises = [vm.attackersPromise, vm.eventsPromise, vm.appsPromise]

        if (!keepFilters) {
          vm.filtersPromise = getFilters()
          promises.push(
            vm.filtersPromise.then(function () {
              if (hasFilters) {
                removeOldSubfilters()
                reloadData(true)
              }
            })
          )
        }

        return $q.all(promises).then(function () {
          vm.noAttacks =
            vm.attackers.total == 0 &&
            vm.events.total == 0 &&
            vm.apps.total == 0 &&
            vm.filters.selected.length == 0

          if (vm.noAttacks) {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: true
            })
          } else {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: false
            })
          }
        })
      }

      function attackerSelect(attacker, $event) {
        attackerMultiSelect([attacker], $event)
      }

      function attackerMultiSelect(attackers, $event) {
        var attackerFound = false,
          removedSubfilter = false

        if ($event && !$event.shiftKey) {
          removedSubfilter = removeSubfilters(function (filter) {
            return (
              filter.group == ATTACK_MONITOR_FILTER_GROUPS.ATTACKERS &&
              attackers.indexOf(filter.value) < 0
            )
          })
        }

        for (var i = 0; i < attackers.length; i++) {
          var attacker = attackers[i],
            attackerFilterFind = function (filter) {
              return (
                filter.group == ATTACK_MONITOR_FILTER_GROUPS.ATTACKERS &&
                filter.value == attacker
              )
            }

          if (itemSelect(attackerFilterFind, removedSubfilter)) {
            attackerFound = true
          }
        }
        if (attackerFound || removedSubfilter) {
          filterChange(true)
        }
      }

      function eventSelect(event) {
        return function ($event) {
          eventMultiSelect([event.event])($event)
        }
      }

      function eventMultiSelect(eventNames) {
        return function ($event) {
          var eventFound = false,
            removedSubfilter = false

          if ($event && !$event.shiftKey) {
            removedSubfilter = removeSubfilters(function (filter) {
              return (
                filter.group == ATTACK_MONITOR_FILTER_GROUPS.RULES &&
                eventNames.indexOf(filter.name) < 0
              )
            })
          }

          for (var i = 0; i < eventNames.length; i++) {
            var eventName = eventNames[i],
              eventFilterFind = function (filter) {
                return (
                  filter.group == ATTACK_MONITOR_FILTER_GROUPS.RULES &&
                  filter.name == eventName
                )
              }

            if (itemSelect(eventFilterFind, removedSubfilter)) {
              eventFound = true
            }
          }
          if (eventFound || removedSubfilter) {
            filterChange(true)
          }
        }
      }

      function appSelect(app) {
        return function ($event) {
          appMultiSelect([app.application])($event)
        }
      }

      function appMultiSelect(appNames) {
        return function ($event) {
          var appFound = false,
            removedSubfilter = false

          if ($event && !$event.shiftKey) {
            removedSubfilter = removeSubfilters(function (filter) {
              return (
                filter.group == ATTACK_MONITOR_FILTER_GROUPS.APPLICATIONS &&
                appNames.indexOf(filter.name) < 0
              )
            })
          }

          for (var i = 0; i < appNames.length; i++) {
            var appName = appNames[i],
              appFilterFind = function (filter) {
                return (
                  filter.group == ATTACK_MONITOR_FILTER_GROUPS.APPLICATIONS &&
                  filter.name == appName
                )
              }

            if (itemSelect(appFilterFind, removedSubfilter)) {
              appFound = true
            }
          }
          if (appFound || removedSubfilter) {
            filterChange(true)
          }
        }
      }

      function itemSelect(findFn, removedSubfilter) {
        var filter = vm.filters.availableFilters.find(findFn)

        if (filter) {
          var selectedIndex = vm.filters.selected.findIndex(findFn)

          if (selectedIndex > -1) {
            if (removedSubfilter) {
              return false
            }

            vm.filters.selected.splice(selectedIndex, 1)
          } else {
            vm.filters.selected.push(filter)
          }
          return true
        }
        return false
      }

      function removeSubfilters(findFn) {
        var removed = false
        while (vm.filters.selected.find(findFn)) {
          var selectedIndex = vm.filters.selected.findIndex(findFn)
          if (selectedIndex > -1) {
            vm.filters.selected.splice(selectedIndex, 1)
            removed = true
          }
        }
        return removed
      }

      function getAttackType(types) {
        var transl = {
          detail_attacks_manualAttack: $translate.instant(
            'detail_attacks_manualAttack'
          ),
          detail_attacks_automatedScan: $translate.instant(
            'detail_attacks_automatedScan'
          )
        }

        var result = '',
          i = 0

        for (; i < types.length; i++) {
          if (result) {
            result += ', '
          }
          // TODO: CONTRAST-18297
          // eslint-disable-next-line default-case
          switch (types[i]) {
            case 'MANUAL':
              result += transl.detail_attacks_manualAttack
              break

            case 'AUTOMATED':
              result += transl.detail_attacks_automatedScan
              break
          }
        }

        return result
      }

      function onDateOptionChange() {
        filterChangeNow()
      }

      function removeOldSubfilters() {
        var i = 0,
          filter = null,
          selectedFilter = null,
          validSubfilters = []
        for (; i < vm.filters.availableFilters.length; i++) {
          filter = vm.filters.availableFilters[i]
          selectedFilter = vm.filters.selected.find(function (current) {
            return (
              filter.group == current.group &&
              filter.value == current.value &&
              filter.name == current.name
            )
          })

          if (selectedFilter) {
            validSubfilters.push(filter)
          }
        }
        vm.filters.selected = validSubfilters
      }

      function mergeSubfilters(subfiltersFrom, subfiltersTo) {
        var i = 0,
          filter = null,
          existingFilter = null
        for (; i < subfiltersFrom.length; i++) {
          filter = subfiltersFrom[i]
          existingFilter = subfiltersTo.find(function (current) {
            return (
              filter.group == current.group &&
              filter.value == current.value &&
              filter.name == current.name
            )
          })

          if (!existingFilter) {
            subfiltersTo.push(filter)
          }
        }
        return subfiltersTo
      }

      function clearFilters() {
        if (vm.filters.selected.length > 0) {
          vm.filters.selected = []
          filterChange(true)
        }
      }

      function attackersCountClick() {
        appsCountClick()
      }

      function attackersNameClick(attacker) {
        _setBotBlockerIpFilters()
        LoadFilterService.setAttackEventAttackers([attacker])
        $location.path(UserService.buildUrl('/attacks/attacks'))
      }

      function eventsCountClick() {
        if (vm.filters.date.label == 'Live') {
          LoadFilterService.setAttacksLive(true)
        } else {
          LoadFilterService.setAttacksDate({
            startDate: vm.filters.date.startDate,
            endDate: vm.filters.date.endDate
          })
        }

        if (!vm.filters.probed) {
          LoadFilterService.setNoProbed(true)
        }

        if (vm.filters.environment.value != 'ALL') {
          LoadFilterService.setAttackEnvironment(vm.filters.environment.value)
        }

        var loadFilters = getLoadFilters()

        if (loadFilters.selectedEvents.length > 0) {
          LoadFilterService.setAttackEventRules(loadFilters.selectedEvents)
        }

        if (loadFilters.selectedApps.length > 0) {
          LoadFilterService.setAttackEventApps(loadFilters.selectedApps)
        }

        if (loadFilters.selectedAttackers.length > 0) {
          LoadFilterService.setAttackEventAttackers(
            loadFilters.selectedAttackers
          )
        }

        if (loadFilters.selectedSeverities.length > 0) {
          LoadFilterService.setAttackSeverities(loadFilters.selectedSeverities)
        }

        _setBotBlockerIpFilters()
        $location.path(UserService.buildUrl('/attacks/events'))
      }

      function appsCountClick() {
        if (vm.filters.date.label == 'Live') {
          LoadFilterService.setAttacksLive(true)
        } else {
          LoadFilterService.setAttacksDate({
            startDate: vm.filters.date.startDate,
            endDate: vm.filters.date.endDate
          })
        }

        if (!vm.filters.probed) {
          LoadFilterService.setNoProbed(true)
        }

        if (vm.filters.environment.value != 'ALL') {
          LoadFilterService.setAttackEnvironment(vm.filters.environment.value)
        }

        var loadFilters = getLoadFilters()

        if (loadFilters.selectedEvents.length > 0) {
          LoadFilterService.setAttackEventRules(loadFilters.selectedEvents)
        }

        if (loadFilters.selectedApps.length > 0) {
          LoadFilterService.setAttackApplications(loadFilters.selectedApps)
        }

        if (loadFilters.selectedAttackers.length > 0) {
          LoadFilterService.setAttackEventAttackers(
            loadFilters.selectedAttackers
          )
        }

        if (loadFilters.selectedSeverities.length > 0) {
          LoadFilterService.setAttackSeverities(loadFilters.selectedSeverities)
        }

        _setBotBlockerIpFilters()
        $location.path(UserService.buildUrl('/attacks/attacks'))
      }

      function onHighRiskClick() {
        LoadFilterRouteService.goToApps(QUICK_FILTERS.APPS.HIGH_RISK.KEY)
      }

      function getLoadFilters() {
        var selectedEvents = [],
          selectedApps = [],
          selectedSeverities = [],
          selectedAttackers = [],
          i = 0

        for (; i < vm.filters.selected.length; i++) {
          var selected = vm.filters.selected[i]
          // TODO: CONTRAST-18297
          // eslint-disable-next-line default-case
          switch (selected.group) {
            case ATTACK_MONITOR_FILTER_GROUPS.ATTACKERS:
              selectedAttackers.push(selected.value)
              break

            case ATTACK_MONITOR_FILTER_GROUPS.RULES:
              if (selected.isSeverity) {
                selectedSeverities.push(selected.value)
              } else {
                selectedEvents.push(selected.name)
              }
              break

            case ATTACK_MONITOR_FILTER_GROUPS.APPLICATIONS:
              selectedApps.push(selected.value)
              break
          }
        }

        return {
          selectedEvents: selectedEvents,
          selectedApps: selectedApps,
          selectedAttackers: selectedAttackers,
          selectedSeverities: selectedSeverities
        }
      }

      function isViewingLive() {
        return vm.filters.date.label == 'Live'
      }

      function _setBotBlockerIpFilters() {
        LoadFilterService.setAttackBB(true)
        LoadFilterService.setAttackIP(true)
      }
    }
  )
